export default __webpack_public_path__ + "static/media/location_preview_polar_plains.2cf21d7c.svg";